import React, { useState } from "react";

export enum DicomViewerState {
  NotInitialized,
  Visible,
  Hidden,
}

export interface DicomViewerVisibility {
  state: DicomViewerState;
  setState: React.Dispatch<React.SetStateAction<DicomViewerState>>;
  studyId?: string;
  setStudyId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const useDicomViewerVisibility = (): DicomViewerVisibility => {
  const [state, setState] = useState(DicomViewerState.NotInitialized);
  const [studyId, setStudyId] = useState<string | undefined>(undefined);

  return {
    state,
    setState,
    studyId,
    setStudyId,
  };
};

export default useDicomViewerVisibility;
